import { useRef } from 'react';
import { useCampaignIdCache } from 'hooks/useCampaignIdCache';

const useCurrentCampaign = () => {
  const campaignSlug = parseCampaignSlugFromUrl(window.location.pathname);

  const { campaignIdCache } = useCampaignIdCache(state => {
    return {
      campaignIdCache: state.campaignIdCache,
    };
  });

  const campaignIdRef = useRef(campaignIdCache[campaignSlug]?.campaignId ?? 'default');
  const campaignId = campaignIdRef.current;

  return { campaignSlug, campaignId, campaignIdRef };
};

function parseCampaignSlugFromUrl(pathname: string) {
  let parts = pathname.split('/c/');
  if (parts.length < 2) {
    throw Error('Invalid URL');
  }
  return parts[1];
}

export { useCurrentCampaign };
